import { render, staticRenderFns } from "./FirstCover.vue?vue&type=template&id=3582673c&scoped=true&"
import script from "./FirstCover.vue?vue&type=script&lang=js&"
export * from "./FirstCover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3582673c",
  null
  
)

export default component.exports